import React, { Component } from "react";
import axios from "axios";
import parseXML from "xml-parse-from-string";

import SVG from 'svg.js';
import 'svg.draggable.js';
import 'svg.connectable.js';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setTranslateX,
  setTranslateY,
  setZoom,
  showHidePathPopover,
  setActivePath,
  setPathPopoverX,
  setPathPopoverY,
  showHidePointPopover,
  setPointPopoverX,
  setPointPopoverY,
  setActivePoint,
  showHideAmenityAssignmentPopover,
  setActiveAmenityAssignment,
  setAmenityAssignmentPopoverX,
  setAmenityAssignmentPopoverY,
  showHideKioskAssignmentPopover,
  setActiveKioskAssignment,
  setKioskAssignmentPopoverX,
  setKioskAssignmentPopoverY,
  setKioskAssignmentRotation,
} from '../../reducers/floorplans';

import {
  addCheckpoint,
  editCheckpoint,
  addCheckpointLink,
  editCheckpointLink,
  removeCheckpoint,
  loadCheckpoints,
  loadCheckpointLinks,
} from '../../reducers/checkpoints';

import {
  addAmenitiesAssignments,
  loadAmenitiesAssignments,
} from '../../reducers/amenities';

import {
  addKiosksAssignments,
  loadKiosksAssignments,
} from '../../reducers/kiosks';


import svgPanZoom from 'svg-pan-zoom';

import './Floorplan.css';

const pointNameTruncate = 6;

class Floorplan extends Component {

  state = {
    floorplanPaths: [],
    floorplanPoints: [],
    floorplanLinks: [],
    snapPointsA: {},
  }


  componentDidMount = () => {
    
    this.draw = SVG(`floorplan-${this.props.floorplan_id}`);
    this.draw.on('click', (event) => {
      event.stopPropagation();

      switch(this.props.toolbar) {
      case 'addPoint':
        this.clickAddCheckpoint(event);
        break;
      case 'addAmenity':
        this.clickAddAmenity(event);
        break;
      case 'addKiosk':
        this.clickAddKiosk(event);
        break;
      default:
      }

    })
    this.gridGroup = this.draw.group();
    this.pathGroup = this.draw.group();
    this.pathIDGroup = this.draw.group();
    this.amenitiesGroup = this.draw.group();
    this.kiosksGroup = this.draw.group();
    this.linksGroup = this.draw.group();
    this.markersGroup = this.draw.group();


    this.pointsGroup = this.draw.group();
    this.pointsGroupText = this.draw.group();

    this.marker = this.draw.marker('end', 20, 20).id('markerDef');
    this.marker.circle(6).center(4, 5).fill('red');

    this.draw.circle(10).fill('rgba(0,0,0,0)').move(10,10);

    const pathArray = [];
    axios.get(this.props.floorplanURL + `?` + Math.random())
      .then((response) => {
        const svgPaths = parseXML(response.data).getElementsByTagName("path");

        Array.from(svgPaths).forEach((path) => {
          const pathItem = {id: path.id, d: path.getAttribute("d") };
          const pathItemSVG = this.pathGroup.path(path.getAttribute("d")).id(`path-${pathItem.id}`).attr({class: 'path-item', 'stroke-width': '0.5', stroke: '#999'}).fill('rgba(255,255,255,0)');
          this.pathIDGroup.plain(`#${path.id}`).font({size: 3, anchor: 'start', fill: '#333'}).x(pathItemSVG.bbox().cx - 1).y(pathItemSVG.bbox().cy - 1).attr('class', 'path-id');
          pathItemSVG.on('contextmenu', (event) => {
            if(this.props.toolbar === 'select') {
              event.preventDefault();
              this.props.setActivePath(pathItem.id);
              this.props.showHidePathPopover(true);
              this.props.showHidePointPopover(false);
              this.props.setPathPopoverX(event.offsetX);
              this.props.setPathPopoverY(event.offsetY);
            }
          });
          pathItemSVG.on('mouseout', (event) => {
            // this.props.showHidePopover(false);
          });
          pathItem.pathItemSVG = pathItemSVG;
          pathArray.push(pathItem);
        });

        this.setState({floorplanPaths: pathArray});
        
      });
    
    this.setState({
      floorplanPaths: pathArray
    }, () => { 
      this.setChildPanZoom();
    } );

  }


  linkPoints = (from, to, link_id = null) => {
    const pointFrom = this.getPointById(from);
    const pointTo = this.getPointById(to);

    if(pointFrom && pointTo){
      const link = pointFrom.SVGItem.connectable({container: this.linksGroup, type : 'straight'}, pointTo.SVGItem);
      // const link = pointFrom.SVGItemPoint.connectable({container: this.linksGroup, type : 'straight'}, pointTo.SVGItemPoint);
      const linkSVGItem ={ link, from, to, id: link_id };
      link.setConnectorColor("rgba(0,0,0,.1)");
      link.setMarker('default', this.markersGroup);
      // link.setMarker(this.markersample, this.markersGroup);
      link.marker.height(3,3);
      this.links.push(linkSVGItem);
    }
  }

  getPointById = (id, log = false) => {
    return this.pointItems.find((point) => {
      return point.id === id;
    });
  }

  componentDidUpdate = (prevProps) => {
    if(!this.props.isLoadingCheckpoints && prevProps.isLoadingCheckpoints !== this.props.isLoadingCheckpoints) {
      this.setFloorplanPoints();
    }

    if(!this.props.isLoadingAmenitiesAssignments && prevProps.isLoadingAmenitiesAssignments !== this.props.isLoadingAmenitiesAssignments) {
      this.setFloorplanAmenities();
    }

    if(!this.props.isLoadingKiosksAssignments && prevProps.isLoadingKiosksAssignments !== this.props.isLoadingKiosksAssignments) {
      this.setFloorplanKiosks();
    }

    if(this.props.isAddingCheckpointLink && prevProps.isisAddingCheckpointLink !== this.props.isAddingCheckpointLink) {
      this.linkPoints(this.props.isAddingCheckpointLinkFrom, this.props.isAddingCheckpointLinkTo);
    }
    
    if(this.props.isRemovingCheckpointLink && prevProps.isRemovingCheckpointLink !== this.props.isRemovingCheckpointLink) {
      const link = this.links.find((link) => {
        return link.id === this.props.isRemovingCheckpointLinkID;
      });
      link.link.connector.remove();
      link.link.marker.remove();
    }

    if(!this.props.isLoadingCheckpointLinks && prevProps.isLoadingCheckpointLinks !== this.props.isLoadingCheckpointLinks) {
      this.setFloorplanPointsLinks();
    }

    if(!this.props.isLoadingStoreAssignments && prevProps.isLoadingStoreAssignments !== this.props.isLoadingStoreAssignments) {
      this.setPathAvailabilityByStoreAssignments();
    }

    if(!this.props.isRemovingAmenitiesAssignments && prevProps.isRemovingAmenitiesAssignments !== this.props.isRemovingAmenitiesAssignments) {
      this.setFloorplanAmenities();
    }

    if(!this.props.isRemovingKiosksAssignments && prevProps.isRemovingKiosksAssignments !== this.props.isRemovingKiosksAssignments) {
      this.setFloorplanKiosks();
    }

    if(prevProps.gridLines !== this.props.gridLines) {
      this.setGridLines();
    }

    if(prevProps.rotation !== this.props.rotation) {
      this.setGridLines();
    }

    if(prevProps.showPoints !== this.props.showPoints) {
      this.setShowPoints();
    }

    if(prevProps.showAmenities !== this.props.showAmenities) {
      this.setShowAmenities();
    }

    if(prevProps.showKiosks !== this.props.showKiosks) {
      this.setShowKiosks();
    }

    if(prevProps.showPathIDs !== this.props.showPathIDs) {
      this.setShowPathIDs();
    }

    if(prevProps.kioskAssignmentRotation !== this.props.kioskAssignmentRotation && this.props.activeKiosk) {
      this.setKioskAssignmentRotation();
    }

    try{
      if(this.props.toolbar !== 'drag') {
        this.panZoomInstance.disablePan();
      } else {
        this.panZoomInstance.enablePan();
      }
    } catch(e){
      
    }

    if(prevProps.toolbar !== this.props.toolbar){
      this.draw.off('click');
      switch(this.props.toolbar) {
      case 'addPoint':
        this.draw.on('click', this.clickAddCheckpoint);
        break;
      case 'addAmenity':
        this.draw.on('click', this.clickAddAmenity);
        break;
      case 'addKiosk':
        this.draw.on('click', this.clickAddKiosk);
        break;
      default:
        break;
      }
    }
    
    try {
      this.setPathAvailabilityByStoreAssignments();
    } catch(e) {

    }


  }

  // addCheckpointLink = (checkpoint_id) => {
  //   this.props.addCheckpointLink({from: this.props.activePoint.id, to: checkpoint_id, weight: distance}, (data) => {
  //     this.props.loadCheckpointLinks(() => {
  //       this.loadActivePointLinks();
  //     });
  //   });
  // }

  setFloorplanPoints = () => {

    this.pointsGroup.clear();
    this.pointItems = [];

    Array.from(this.props.checkpoints).forEach((point) => {
      if(point.floor_plan_id === this.props.floorplan_id){
        const pointItem = {id: point.id, checkpoint_name: point.checkpoint_name, x: point.x, y: point.y, floor_plan_id: this.props.activeFloorplanID };
        const pointItemSVG = this.pointsGroup.group().translate(pointItem.x -1, pointItem.y -1).id(`point-${pointItem.id}`).attr('class', 'point-item');

        const pointItemSVGPoint = pointItemSVG.group().translate(0, 0).id(`point-point${pointItem.id}`);
        pointItemSVGPoint.circle(7).fill('rgba(255,255,255,0)').cx(1).cy(1);
        pointItemSVGPoint.circle(2).fill('#f06');

        const pointItemSVGText = pointItemSVG.group();
        pointItemSVGText.plain(pointItem.checkpoint_name.substring(0,pointNameTruncate) + (pointItem.checkpoint_name.length > pointNameTruncate ? '...' : '')).font({size: 1, anchor: 'start', fill: '#f06'}).x(2).y(.2).attr('class', 'point-name');
        // const pointItemSVGText = this.pointsGroupText.plain(pointItem.checkpoint_name).font({size: 2, anchor: 'start', fill: '#f06'}).x(pointItem.x).y(pointItem.y).attr('class', 'point-name');
        pointItemSVG.draggable();
        pointItemSVG.draggable().on('beforedrag', (event) => {
          if(this.props.toolbar !== 'select') {
            event.preventDefault();
          }
        });
        pointItemSVG.draggable().on('dragmove', (event) => {
          if(this.props.toolbar !== 'select') {
            event.preventDefault();
          }
        })
        pointItemSVG.draggable().on('dragend', (event) => {
          if(this.props.toolbar === 'select') {
            pointItem.x = pointItemSVG.x() + 1;
            pointItem.y = pointItemSVG.y() + 1;
            this.props.editCheckpoint(pointItem);

            // Get all points connected to this point and update weight with distance formula
            this.updateWeightsToThisPoint(pointItem);

            // Get all points connected from this point and update weight with distance formula
            this.updateWeightsFromThisPoint(pointItem);
          }
        });
        pointItemSVG.get(0).get(1).on('mouseover', (event) => {
          if(this.props.toolbar === 'addConnector') {
            pointItemSVG.get(0).get(1).fill('#000');
          }
        });
        pointItemSVG.get(0).get(1).on('click', (event) => {

          if(this.props.toolbar === 'addConnector' && Object.keys(this.state.snapPointsA).length === 0) {
            const snapPointsA = {snapPointsASVG: pointItemSVG.get(0).get(1), id: pointItem.id, x: pointItem.x, y: pointItem.y};
            this.setState({snapPointsA});
            this.spawnPointForSnapping(event);
          } else if(this.props.toolbar === 'addConnector' && this.state.snapPointsA.snapPointsASVG === pointItemSVG.get(0).get(1)) {
            this.draw.off('mousemove');

            try {
              this.snapPointsLink.connector.remove();
              this.snapPointsLink.marker.remove();
            } catch (e) {

            }

            this.setState({snapPointsA: {}});
          } else if(this.props.toolbar === 'addConnector' && Object.keys(this.state.snapPointsA).length !== 0) {

            this.snapPointsLink.connector.remove();
            this.snapPointsLink.marker.remove();

            this.state.snapPointsA.snapPointsASVG.fill('#f06');
            this.draw.off('mousemove');

            let distance = Math.sqrt( Math.pow(this.state.snapPointsA.x - pointItem.x, 2) + Math.pow(this.state.snapPointsA.y - pointItem.y, 2) );
            this.props.addCheckpointLink({from: this.state.snapPointsA.id, to: pointItem.id, weight: distance}, () => {  
              this.props.loadCheckpointLinks( () => {
              });
            });
            this.setState({snapPointsA: {}});
          }

        });
        pointItemSVG.get(0).get(1).on('mouseout', (event) => {

          if(this.props.toolbar === 'addConnector' && Object.keys(this.state.snapPointsA).length === 0) {
            pointItemSVG.get(0).get(1).fill('#f06');
          }

          if(this.props.toolbar === 'addConnector' && this.state.snapPointsA.snapPointsASVG !== pointItemSVG.get(0).get(1)) {
            pointItemSVG.get(0).get(1).fill('#f06');
          }

        });
        pointItemSVG.on('contextmenu', (event) => {
          if(this.props.toolbar === 'select') {
            event.preventDefault();
            this.props.showHidePointPopover(true);
            this.props.showHidePathPopover(false);
            this.props.showHideAmenityAssignmentPopover(false);
            this.props.showHideKioskAssignmentPopover(false);
            this.props.setPointPopoverX(event.offsetX);
            this.props.setPointPopoverY(event.offsetY);
            this.props.setActivePoint(pointItem);
            this.dragged = false;
          }
        });
        pointItem.SVGItem = pointItemSVG; 
        pointItem.SVGItemPoint = pointItemSVGPoint; 

        this.pointItems.push(pointItem);
      }
    });
  }

  updateWeightsToThisPoint = (thisPoint) => {
    this.props.checkpointLinks.forEach((checkpointLink) => {
      if(checkpointLink.to.id === thisPoint.id) {
        let distance = Math.sqrt( Math.pow(checkpointLink.from.x - thisPoint.x, 2) + Math.pow(checkpointLink.from.y - thisPoint.y, 2) );
        this.props.editCheckpointLink(checkpointLink.id, {to: thisPoint.id, from: checkpointLink.from.id, weight: distance});
      }
    })
  }

  updateWeightsFromThisPoint = (thisPoint) => {
    this.props.checkpointLinks.forEach((checkpointLink) => {
      if(checkpointLink.from.id === thisPoint.id) {
        let distance = Math.sqrt( Math.pow(thisPoint.x - checkpointLink.to.x, 2) + Math.pow(thisPoint.y - checkpointLink.to.y, 2) );
        this.props.editCheckpointLink(checkpointLink.id, {to: checkpointLink.to.id, from: thisPoint.id, weight: distance});
      }
    })
  }

  spawnPointForSnapping = (event) => {

    this.snapPointsLink = null;
    this.pointForSnapping = null;
    
    var pan = this.panZoomInstance.getPan();
    var sizes = this.panZoomInstance.getSizes();
    var zoom = sizes.realZoom;

    var x, y, pt;
    pt = this.cursorPoint(event);

    x = pt.x;
    y = pt.y;

    x = (x - pan.x) / zoom;
    y = (y - pan.y)/zoom;
    this.pointForSnapping = this.pointsGroup.circle(1).fill('rgba(255,255,255,.0)').x(x - 1).y(y - 1);
    this.snapPointsLink = this.state.snapPointsA.snapPointsASVG.parent().parent().connectable({container: this.linksGroup, type : 'straight'}, this.pointForSnapping );
    this.snapPointsLink.setConnectorColor("rgba(0,0,0,.1)");
    this.snapPointsLink.setMarker('default', this.markersGroup);
    this.snapPointsLink.marker.height(3,3);

    this.updateSpawnPointForSnapping();
  }

  updateSpawnPointForSnapping = () => {
    this.draw.on('mousemove', (event) => {
      var pan = this.panZoomInstance.getPan();
      var sizes = this.panZoomInstance.getSizes();
      var zoom = sizes.realZoom;

      var x, y, pt;
      pt = this.cursorPoint(event);

      x = pt.x;
      y = pt.y;

      x = (x - pan.x) / zoom;
      y = (y - pan.y)/zoom;

      this.pointForSnapping.x(x - 1).y(y - 1)

      this.snapPointsLink.connector.remove();
      this.snapPointsLink.marker.remove();

      this.snapPointsLink = this.state.snapPointsA.snapPointsASVG.parent().parent().connectable({container: this.linksGroup, type : 'straight'}, this.pointForSnapping );
      this.snapPointsLink.setConnectorColor("rgba(0,0,0,.1)");
      this.snapPointsLink.setMarker('default', this.markersGroup);
      this.snapPointsLink.marker.height(3,3);

    })

    this.draw.on('contextmenu', (event) => {
      event.preventDefault();
      this.draw.off('mousemove');
      try {
        this.state.snapPointsA.snapPointsASVG.fill('#f06');
        this.snapPointsLink.connector.remove();
        this.snapPointsLink.marker.remove();
      } catch (e) {

      }

      this.setState({snapPointsA: {}});
    })

    // setTimeout(() => {
    //   this.draw.off('mousemove');
    // }, 5000);
  }

  getFileURL = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  getFileURLApp = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  setFloorplanAmenities = () => {

    this.amenitiesGroup.clear();
    this.amenitiesItems = [];

    Array.from(this.props.amenitiesassignments).forEach((amenityassignment) => {
      if(amenityassignment.floorplan_id === this.props.floorplan_id){
        const amenityItem = {id: amenityassignment.mil_id, amenity_name: amenityassignment.amenity.amenity, x: amenityassignment.coordinate_x, y: amenityassignment.coordinate_y };
        const amenityItemSVG = this.amenitiesGroup.group().translate(amenityItem.x -1, amenityItem.y -1).id(`point-${amenityItem.id}`).attr('class', 'amenity-item');
    
        const amenityItemSVGPoint = amenityItemSVG.group().translate(0, 0);
        amenityItemSVGPoint.circle(10).fill('#0747A6').attr('class', 'amenity-item').cx(1).cy(1);
        amenityItemSVGPoint.circle(10).fill('rgba(255,255,255,0)').cx(1).cy(1);
        amenityItemSVGPoint.image(this.getFileURL(amenityassignment.amenity.item_image), 6, 6).cx(1).cy(1);

        amenityItemSVG.on('contextmenu', (event) => {
          if(this.props.toolbar === 'select') {
            event.preventDefault();
            this.props.showHidePointPopover(false);
            this.props.showHidePathPopover(false);
            this.props.showHideAmenityAssignmentPopover(true);
            this.props.showHideKioskAssignmentPopover(false);
            this.props.setAmenityAssignmentPopoverX(event.offsetX);
            this.props.setAmenityAssignmentPopoverY(event.offsetY);
            this.props.setActiveAmenityAssignment(amenityItem);
          }
        });

        const amenityItemSVGText = amenityItemSVG.group();
        amenityItemSVGText.plain(`${amenityItem.id} - ${amenityItem.amenity_name}`).font({size: 3, anchor: 'start', fill: '#0747A6'}).x(7).y(0).attr('class', 'amenity-name');

        this.amenitiesItems.push(amenityItem);
      }
    });
  }

  setFloorplanKiosks = () => {

    this.kiosksGroup.clear();
    this.kiosksItems = [];

    Array.from(this.props.kiosksassignments).forEach((kioskassignment) => {
      if(kioskassignment.floorplan_id === this.props.floorplan_id){
        const kioskItem = {id: kioskassignment.mil_id, kiosk_name: kioskassignment.kiosk.kiosk, x: kioskassignment.coordinate_x, y: kioskassignment.coordinate_y, pointofview: kioskassignment.pointofview, floorplan_id: kioskassignment.floorplan_id, kiosk_id: kioskassignment.kiosk.kiosk_id };
        const kioskItemSVG = this.kiosksGroup.group().translate(kioskItem.x -1, kioskItem.y -1).id(`point-${kioskItem.id}`).attr('class', 'kiosk-item');
    
        const kioskItemSVGPoint = kioskItemSVG.group().translate(0, 0);
        kioskItemSVGPoint.circle(8).fill('#333').attr('class', 'kiosk-item').cx(1).cy(1);
        kioskItemSVGPoint.polygon('1,1 -1,3 1,-2 3,3').fill('white')
        kioskItemSVGPoint.circle(12).fill('rgba(255,255,255,0)').cx(1).cy(1);
        // kioskItemSVGPoint.image(this.getFileURLApp('if_ic_tv_48px_352186.png'), 6, 6).cx(1).cy(1);

        kioskItemSVGPoint.rotate(kioskItem.pointofview);
        

        kioskItemSVGPoint.on('contextmenu', (event) => {
          if(this.props.toolbar === 'select') {
            event.preventDefault();
            this.props.showHidePointPopover(false);
            this.props.showHidePathPopover(false);
            this.props.showHideAmenityAssignmentPopover(false);
            this.props.showHideKioskAssignmentPopover(true);
            this.props.setKioskAssignmentPopoverX(event.offsetX);
            this.props.setKioskAssignmentPopoverY(event.offsetY);
            this.props.setActiveKioskAssignment(kioskItem);
            this.props.setKioskAssignmentRotation(kioskItem.pointofview);
          }
        });

        const kioskItemSVGText = kioskItemSVG.group();
        kioskItemSVGText.plain(`${kioskItem.id} - ${kioskItem.kiosk_name}`).font({size: 3, anchor: 'start', fill: '#333'}).x(7).y(0).attr('class', 'kiosk-name');
        kioskItem.kioskItemSVGPoint = kioskItemSVGPoint;

        this.kiosksItems.push(kioskItem);
      }
    });
  }

  setFloorplanPointsLinks = () => {

    this.linksGroup.clear();
    this.markersGroup.clear();
    this.links = [];

    Array.from(this.props.checkpointLinks).forEach((link) => {
      this.linkPoints(link.from.id, link.to.id, link.id);
    });
  }

  setChildPanZoom = () => {
    try {

      const onPan = (event) => {
        this.props.showHidePointPopover(false);
        this.props.showHidePathPopover(false);
        this.props.showHideAmenityAssignmentPopover(false);
        this.props.showHideKioskAssignmentPopover(false);
        this.props.setZoom(this.panZoomInstance.getZoom());
        this.props.setTranslateX(event.x);
        this.props.setTranslateY(event.y);
      };

      const onZoom = (event) => {
        this.props.showHidePointPopover(false);
        this.props.showHidePathPopover(false);
        this.props.showHideAmenityAssignmentPopover(false);
        this.props.showHideKioskAssignmentPopover(false);
        this.props.setZoom(event);
        this.props.setTranslateX(this.panZoomInstance.getPan().x);
        this.props.setTranslateY(this.panZoomInstance.getPan().y);
      }

      this.panZoomInstance = svgPanZoom('.SVGContainer', {
        zoomEnabled: true,
        controlIconsEnabled: false,
        // fit: true,
        // center: true,
        minZoom: 0.01,
        maxZoom: 0.5,
        onPan: onPan,
        onZoom: onZoom
      });

      this.panZoomInstance.zoom(this.props.zoom);
      // this.panZoomInstance.pan({x: this.props.translateX, y: this.props.translateY});
      // Set Center
      if(this.props.translateX === 0 && this.props.translateY === 0) {
        // this.panZoomInstance.pan({x: this.panZoomInstance.getSizes().width * -1, y: this.panZoomInstance.getSizes().height * -1});
        this.panZoomInstance.pan({x: this.props.translateX, y: this.props.translateY});
      } else {
        this.panZoomInstance.pan({x: this.props.translateX, y: this.props.translateY});
      }

      try {
        this.setFloorplanPoints();
        this.setFloorplanAmenities();
        this.setFloorplanKiosks();
        this.setFloorplanPointsLinks();
      } catch(e) {
        
      }

      this.gridLines = this.gridGroup.rect(10000, 10000).cx(0).cy(0);
      this.pattern = this.draw.pattern(20, 20, (add) => {
        add.line(0, 0, 0, 20).stroke({ width: 1 }).attr({'stroke': 'rgba(0,0,0,.1)'})
        add.line(0, 0, 20, 0).stroke({ width: 1 }).attr({'stroke': 'rgba(0,0,0,.1)'})
      });
      this.setGridLines();

    } catch(e) {

    }
  }

  setGridLines = () => {
    if(this.props.gridLines){
      this.gridLines.fill(this.pattern); 
    } else {
      this.gridLines.fill('rgba(255,255,255,0)'); 
    }

    this.gridLines.rotate(this.props.rotation);
  }

  setShowPoints = () => {
    if(this.props.showPoints){
      this.pointsGroup.show(); 
      this.markersGroup.show(); 
      this.linksGroup.show(); 
    } else {
      this.pointsGroup.hide(); 
      this.markersGroup.hide(); 
      this.linksGroup.hide(); 
    }
  }

  setShowAmenities = () => {
    if(this.props.showAmenities){
      this.amenitiesGroup.show(); 
    } else {
      this.amenitiesGroup.hide(); 
    }
  }

  setShowKiosks = () => {
    if(this.props.showKiosks){
      this.kiosksGroup.show(); 
    } else {
      this.kiosksGroup.hide(); 
    }
  }

  setShowPathIDs = () => {
    if(this.props.showPathIDs){
      this.pathIDGroup.show(); 
    } else {
      this.pathIDGroup.hide(); 
    }
  }

  setKioskAssignmentRotation = () => {
    const activeKioskItem = this.kiosksItems.find((kioskItem) => {
      return kioskItem.id === this.props.activeKioskAssignment.id;
    });

    if(activeKioskItem) {
      activeKioskItem.kioskItemSVGPoint.rotate(this.props.kioskAssignmentRotation);
    }

  }

  clickAddCheckpoint = (event) => {
    var pan = this.panZoomInstance.getPan();
    //var zoom = panZoom.getZoom();
    var sizes = this.panZoomInstance.getSizes();
    var zoom = sizes.realZoom;

    var x, y, pt;
    pt = this.cursorPoint(event);

    x = pt.x;
    y = pt.y;

    x = (x - pan.x) / zoom;
    y = (y - pan.y)/zoom;

    const pointItem = {checkpoint_name: "new", x: x, y: y, floor_plan_id: this.props.activeFloorplanID };

    this.props.addCheckpoint(pointItem, (id) => {
      this.props.loadCheckpoints();
      pointItem.id = id;
      const pointItemSVG = this.pointsGroup.group().translate(pointItem.x -1, pointItem.y - 1).id(`point-point${pointItem.id}`).attr('class', 'point-item');
      pointItemSVG.circle(2).fill('#f06').attr('class', 'point-item');
      
      const pointItemSVGPoint = pointItemSVG.group().translate(0, 0);
      pointItemSVGPoint.circle(2).fill('#f06').attr('class', 'point-item');
      pointItemSVGPoint.circle(7).fill('rgba(255,255,255,0)').cx(1).cy(1);

      const pointItemSVGText = pointItemSVG.group();
      // pointItemSVGText.plain(pointItem.checkpoint_name).font({size: 2, anchor: 'start', fill: '#f06'}).x(2).y(0).attr('class', 'point-name');
      pointItemSVGText.plain(pointItem.checkpoint_name.substring(0,pointNameTruncate) + (pointItem.checkpoint_name.length > pointNameTruncate ? '...' : '')).font({size: 1, anchor: 'start', fill: '#f06'}).x(2).y(.2).attr('class', 'point-name');
      pointItemSVG.draggable();
      pointItemSVG.draggable().on('beforedrag', (event) => {
        if(this.props.toolbar === 'drag') {
          event.preventDefault();
        }
      });
      pointItemSVG.draggable().on('dragmove', (event) => {
        if(this.props.toolbar === 'drag') {
          event.preventDefault();
        }
      })
      pointItemSVG.draggable().on('dragend', (event) => {
        if(this.props.toolbar !== 'drag') {
          this.props.editCheckpoint(pointItem);
        }
      });
      pointItemSVG.on('contextmenu', (event) => {
        if(this.props.toolbar !== 'drag') {
          event.preventDefault();
          this.props.showHidePointPopover(true);
          this.props.showHidePathPopover(false);
          this.props.setPointPopoverX(event.offsetX);
          this.props.setPointPopoverY(event.offsetY);
          this.props.setActivePoint(pointItem);
          this.dragged = false;
        }
      });
      pointItem.SVGItem = pointItemSVG; 
    });
  }

  clickAddAmenity = (event) => {
    var pan = this.panZoomInstance.getPan();
    //var zoom = panZoom.getZoom();
    var sizes = this.panZoomInstance.getSizes();
    var zoom = sizes.realZoom;

    var x, y, pt;
    pt = this.cursorPoint(event);

    x = pt.x;
    y = pt.y;

    x = (x - pan.x) / zoom;
    y = (y - pan.y)/zoom;

    const amenityItem = {amenity_id: this.props.activeAmenity, coordinate_x: x, coordinate_y: y, floor_plan_id: this.props.activeFloorplanID };

    this.props.addAmenitiesAssignments(amenityItem, () => {

      this.props.loadAmenitiesAssignments(() => {
        this.setFloorplanAmenities();
      })

    });

  }

  clickAddKiosk = (event) => {
    var pan = this.panZoomInstance.getPan();
    //var zoom = panZoom.getZoom();
    var sizes = this.panZoomInstance.getSizes();
    var zoom = sizes.realZoom;

    var x, y, pt;
    pt = this.cursorPoint(event);

    x = pt.x;
    y = pt.y;

    x = (x - pan.x) / zoom;
    y = (y - pan.y)/zoom;

    const kioskItem = {kiosk_id: this.props.activeKiosk, coordinate_x: x, coordinate_y: y, floor_plan_id: this.props.activeFloorplanID };

    this.props.addKiosksAssignments(kioskItem, () => {

      this.props.loadKiosksAssignments(() => {
        this.setFloorplanKiosks();
      })

    });

  }

  getActiveAmenity = () => {
    return this.props.amenities.find((amenity) => {
      return amenity.amenity_id === this.props.activeAmenity;
    });
  }

  getActiveKiosk = () => {
    return this.props.kiosks.find((kiosk) => {
      return kiosk.kiosk_id === this.props.activeKiosk;
    });
  }

  cursorPoint = (event) => {
    var svg = document.getElementsByClassName('SVGContainer')[0];
    var pt = svg.createSVGPoint();
    pt.x = event.clientX;
    pt.y = event.clientY;
    return pt.matrixTransform(svg.getScreenCTM().inverse());
  }

  setPathAvailabilityByStoreAssignments = () => {
    this.state.floorplanPaths.forEach((floorplanPath) => {
      const storeAssignment = this.props.storeassignments.find((storeassignment) => {
        return storeassignment.room_name === floorplanPath.id;
      });


      if(storeAssignment) {
        floorplanPath.pathItemSVG.fill('#CCC');
      } else {
        floorplanPath.pathItemSVG.fill('rgba(255,255,255,0)')
      }

    })
  }

  componentWillUnmount = () => {
    this.draw.clear();
  }

  render() {
    return (
       <svg width="100%" id={`floorplan-${this.props.floorplan_id}`} className={`SVGContainer ${this.props.toolbar}`} style={{height: '100%', flexGrow: 1}}></svg>      
    );
  }
}

const mapStateToProps = state => ({
  translateX: state.floorplans.translateX,
  translateY: state.floorplans.translateY,
  zoom: state.floorplans.zoom,
  activeFloorplanID: state.floorplans.activeFloorplanID,
  isAddingCheckpoint: state.checkpoints.isAddingCheckpoint,
  isAddingCheckpointLink: state.checkpoints.isAddingCheckpointLink,
  isAddingCheckpointLinkFrom: state.checkpoints.isAddingCheckpointLinkFrom,
  isAddingCheckpointLinkTo: state.checkpoints.isAddingCheckpointLinkTo,
  isRemovingCheckpointLink: state.checkpoints.isRemovingCheckpointLink,
  isRemovingCheckpointLinkID: state.checkpoints.isRemovingCheckpointLinkID,
  checkpoints: state.checkpoints.checkpoints,
  isLoadingCheckpoints: state.checkpoints.isLoadingCheckpoints,
  checkpointLinks: state.checkpoints.checkpointLinks,
  isLoadingCheckpointLinks: state.checkpoints.isLoadingCheckpointLinks,
  isLoadingStoreAssignments: state.stores.isLoadingStoreAssignments,
  storeassignments: state.stores.storeassignments,
  gridLines: state.floorplans.gridLines,
  rotation: state.floorplans.rotation,
  amenities: state.amenities.amenities,
  isLoadingAmenitiesAssignments: state.amenities.isLoadingAmenitiesAssignments,
  amenitiesassignments: state.amenities.amenitiesassignments,
  activeAmenity: state.floorplans.activeAmenity,
  showPoints: state.floorplans.showPoints,
  showAmenities: state.floorplans.showAmenities,
  showPathIDs: state.floorplans.showPathIDs,
  kiosks: state.kiosks.kiosks,
  isLoadingKiosksAssignments: state.kiosks.isLoadingKiosksAssignments,
  kiosksassignments: state.kiosks.kiosksassignments,
  activeKiosk: state.floorplans.activeKiosk,
  showKiosks: state.floorplans.showKiosks,
  activeKioskAssignment: state.floorplans.activeKioskAssignment,
  kioskAssignmentRotation: state.floorplans.kioskAssignmentRotation,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setTranslateX,
      setTranslateY,
      setZoom,
      showHidePathPopover,
      setActivePath,
      setPathPopoverX,
      setPathPopoverY,
      showHidePointPopover,
      setPointPopoverX,
      setPointPopoverY,
      addCheckpoint,
      editCheckpoint,
      removeCheckpoint,
      setActivePoint,
      addAmenitiesAssignments,
      loadAmenitiesAssignments,
      showHideAmenityAssignmentPopover,
      setActiveAmenityAssignment,
      setAmenityAssignmentPopoverX,
      setAmenityAssignmentPopoverY,
      addKiosksAssignments,
      loadKiosksAssignments,
      showHideKioskAssignmentPopover,
      setActiveKioskAssignment,
      setKioskAssignmentPopoverX,
      setKioskAssignmentPopoverY,
      addCheckpointLink,
      editCheckpointLink,
      loadCheckpointLinks,
      setKioskAssignmentRotation,
      loadCheckpoints,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Floorplan);



// WEBPACK FOOTER //
// ./src/components/Floorplan/Floorplan.js